import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { VideoNodeFrontend } from "./VideoNodeFrontend";

export const VideoExtensionFrontend = Node.create({
  name: "video",

  group: "block",

  atom: true,

  draggable: false, // Not draggable on frontend

  addAttributes() {
    return {
      url: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-url"),
        renderHTML: (attributes) => {
          return {
            "data-url": attributes.url,
          };
        },
      },
      title: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-title"),
        renderHTML: (attributes) => {
          return {
            "data-title": attributes.title,
          };
        },
      },
      description: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-description"),
        renderHTML: (attributes) => {
          return {
            "data-description": attributes.description,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-video-node]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", { ...HTMLAttributes, "data-video-node": "" }, 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoNodeFrontend);
  },
});
